// icons must match order of LeaveCaseNoteVisibilityOption enum!
export const VISIBILITY_ICONS: string[] = ["person", "supervisor_account", "location_city", "business"];
